import axios from 'axios'
import {getApiUrls} from "@/http/base.http";

export function getArchivalList(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/list`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getFileEnabled(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/file/enable`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getFileDisbled(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/file/disable`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getFileDelete(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/file/delete`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

